import { getCategoryLink } from './utils/category.js';

var TabNames;
(function (TabNames) {
    TabNames[TabNames["Description"] = 0] = "Description";
    TabNames[TabNames["Details"] = 1] = "Details";
    TabNames[TabNames["ProductTab3"] = 2] = "ProductTab3";
    TabNames[TabNames["ProductTab4"] = 3] = "ProductTab4";
    TabNames[TabNames["ShippingReturns"] = 4] = "ShippingReturns";
    TabNames[TabNames["AccorRewards"] = 5] = "AccorRewards";
})(TabNames || (TabNames = {}));
({
    [TabNames.Description]: 'description',
    [TabNames.Details]: 'details',
    [TabNames.ProductTab3]: '3',
    [TabNames.ProductTab4]: '4',
    [TabNames.ShippingReturns]: 'shipping-returns',
    [TabNames.AccorRewards]: 'rewards',
});

const getProductImages = (product) => {
    const smallImages = product.small_image ? [product.small_image] : [];
    const additionalImages = product.additional_image || [];
    return [...smallImages, ...additionalImages];
};
const getBreadcrumbs = (product, locale) => {
    let productCategories = product.categories || [];
    // "product.categories" array contains a list of all categories a product is related to
    // as it was agreed with Magento team, we are using the first related category from the array
    productCategories = productCategories.slice(0, 1);
    return productCategories.map(item => ({
        name: item.name,
        url: getCategoryLink(item.url_path, locale),
    }));
};
const getTabsLabel = (type) => {
    switch (type) {
        case TabNames.Description:
            return 'description';
        case TabNames.Details:
            return 'details';
        case TabNames.ProductTab3:
            return 'productTab3';
        case TabNames.ProductTab4:
            return 'productTab4';
        case TabNames.ShippingReturns:
            return 'shippingAndReturns';
        case TabNames.AccorRewards:
            return '$accor.accorRewards';
        default:
            return '';
    }
};
const calculateStikyTopProduct = (wrapper) => {
    const configCont = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector('.product-config-wrapper');
    if (!configCont) {
        return;
    }
    const configHeight = configCont.scrollHeight;
    const viewportHeight = window.innerHeight;
    let heightDifference = configHeight - viewportHeight;
    heightDifference = heightDifference < 0 ? 0 : heightDifference;
    configCont.style.top = `-${heightDifference}px`;
    if (window.innerWidth <= 768)
        configCont.style.top = '';
};

export { TabNames as T, getProductImages as a, getTabsLabel as b, calculateStikyTopProduct as c, getBreadcrumbs as g };
//# sourceMappingURL=helper-qZTqmbEO.js.map
